import type { ImportMode } from "../../../types/customCsvImport";

export const CUSTOM_CSV_WIZARD_STEPS = [
  { id: "start", label: "Choose layout" },
  { id: "upload", label: "Upload" },
  { id: "map", label: "Map columns" },
  { id: "formats", label: "Formats" },
  { id: "metadata", label: "Account details" },
  { id: "preview", label: "Preview" },
  { id: "acknowledge", label: "Confirm warnings" },
  { id: "import", label: "Import" },
] as const;

export type CustomCsvWizardStepId = (typeof CUSTOM_CSV_WIZARD_STEPS)[number]["id"];

export const SIDE_TARGET_OPTIONS = ["BUY", "SELL"] as const;
export const POSITION_EFFECT_OPTIONS = ["OPEN", "CLOSE"] as const;

/** Plain-language explanation whenever file-order trade pairing applies. */
export const FILE_ORDER_PAIRING_EXPLANATION =
  "Tessera pairs buys and sells in the order they appear in your file. The first buy matches the first sell, and so on.";

export function stepIndex(stepId: CustomCsvWizardStepId): number {
  return CUSTOM_CSV_WIZARD_STEPS.findIndex((s) => s.id === stepId);
}

export function importModeNeedsAckStep(warningsCount: number): boolean {
  return warningsCount > 0;
}

export function visibleWizardSteps(
  previewWarningsCount: number
): Array<(typeof CUSTOM_CSV_WIZARD_STEPS)[number]> {
  if (!importModeNeedsAckStep(previewWarningsCount)) {
    return CUSTOM_CSV_WIZARD_STEPS.filter((s) => s.id !== "acknowledge");
  }
  return [...CUSTOM_CSV_WIZARD_STEPS];
}

export const IMPORT_MODE_VISUAL_KEYS: Record<ImportMode, string> = {
  closed_trade_single: "single_row",
  closed_trade_paired: "paired_rows",
  execution_rows: "fills",
};
